import { FC } from "react";
import { Route, Switch } from 'react-router-dom';
import Tutor from '../pages/tutor';
import TutorAssess from '../pages/tutor/assess';
import TutorAssessWs from '../pages/tutor/assess-ws';
import TutorAssessCb from '../pages/tutor/assess-cb';
import TutorClass from '../pages/tutor/class';
import StudentCare from '../pages/student/care';

const TutorRouter: FC = () => {
  return (
    <Switch>
      <Route path="/" exact component={Tutor} />
      <Route path='/assess' exact component={TutorAssess} />
      <Route path='/assess-ws' exact component={TutorAssessWs} />
      <Route path='/assess-cb' exact component={TutorAssessCb} />
      <Route path='/student/care' exact component={StudentCare} />
    </Switch>
  );
}

export default TutorRouter;
